import axios from 'axios';
import { getAuthHeaders } from './userController';

const BASE_URL = 'https://yokomo.api.ikeytechnologies.com/comandos/';

// Obtener todos los comandos pendientes
export const fetchComandosPendientes = async () => {
  try {
    const response = await axios.get(BASE_URL, getAuthHeaders());
    return response.data;
  } catch (error) {
    console.error('Error al obtener los comandos pendientes:', error);
    throw error;
  }
};

// Obtener un comando específico por ID
export const fetchComando = async (id) => {
  try {
    const response = await axios.get(`${BASE_URL}${id}/`, getAuthHeaders());
    return response.data;
  } catch (error) {
    console.error(`Error al obtener el comando con ID ${id}:`, error);
    throw error;
  }
};

// Eliminar un comando específico por ID
export const deleteComando = async (id) => {
  try {
    const response = await axios.delete(`${BASE_URL}${id}/`, getAuthHeaders());
    return response.data;
  } catch (error) {
    console.error(`Error al eliminar el comando con ID ${id}:`, error);
    throw error;
  }
};
